/**
 * Me
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/me`

const me = {
  namespaced: true,
  actions: {
    show ({ commit }) {
      const api_path = `${API_PATH}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    update ({ commit },{ params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default me

